import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { signIn } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", { session_id: sessionId });
        signIn(data.token, data.user);
        navigate("/", { replace: true });
      } catch (e) {
        toast.error(errMsg(e));
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, signIn]);

  return null;
}
